export default (() => {
	if (process.env.NODE_ENV === "test") return "www.tidrapport24.se";
	// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") return "http://192.168.1.201:8000";
	// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") return "http://nya.tidrapport24.se";
	if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") return "http://127.0.0.1:8000";
	return "";
})();
